<p-popover #popover
           [styleClass]="class()"
           [appendTo]="resolvedAppendTo()"
           (onShow)="onShow.emit($event)"
>

    @if (showCloseIcon()) {
        <p-button
            class="app-popover-close-button"
            pTooltip="Chiudi" tooltipPosition="top"
            severity="primary"
            [rounded]="true"
            size="small"
            icon="fa fa-times"
            (click)="close($event)"
        ></p-button>
    }

    <ng-content></ng-content>

</p-popover>
